import { AxiosInstance } from 'axios';

import { axios } from '../../../../api/axios-instance';
import { sizeTablesEndpoints } from '../../../../constants';
import { DeleteItemsInput } from '../../../../types';
import { ISizeTable, ISizeTables } from '../../entities/size-table';
import { CreateSizeTableInput } from '../../schemas/size-table.schema';

export class SizeTablesApi {
  #requestInstance: AxiosInstance;

  constructor(axiosInstance: AxiosInstance) {
    this.#requestInstance = axiosInstance;
  }

  getAllSizeTables = async (): Promise<Partial<ISizeTables>> => {
    return this.#requestInstance.get(sizeTablesEndpoints.sizeTables);
  };

  getSizeTableById = async (id: number): Promise<ISizeTable> => {
    return this.#requestInstance.get(sizeTablesEndpoints.getSizeTableById(id));
  };

  create = async (table: CreateSizeTableInput): Promise<ISizeTable> => {
    return this.#requestInstance.post(sizeTablesEndpoints.sizeTables, table);
  };

  update = async (table: ISizeTable): Promise<ISizeTable> => {
    return this.#requestInstance.patch(sizeTablesEndpoints.getSizeTableById(table.id), table);
  };

  deleteSizeTable = async (id: number): Promise<void> => {
    return this.#requestInstance.delete(sizeTablesEndpoints.getSizeTableById(id));
  };

  deleteManyTables = async (input: DeleteItemsInput): Promise<void> => {
    return this.#requestInstance.delete(sizeTablesEndpoints.sizeTables, { data: input });
  };
}

export const sizeTablesApi = new SizeTablesApi(axios);
